interface Timestamp {
    startTimestamp: number;
    endTimestamp: number;
    timestampPostRsvpProcessing?: number;
}

const timeToFetchMeetingMessage = {};

const timeToFetchConflictingMeetings = {};

export const setTimeToFetchMeetingMessage = (
    itemId: string,
    startTimestamp: number,
    endTimestamp: number,
    timestampPostRsvpProcessing: number
) => {
    if (!itemId || !startTimestamp || !startTimestamp || !timestampPostRsvpProcessing) {
        return;
    }

    timeToFetchMeetingMessage[itemId] = {
        startTimestamp,
        endTimestamp,
        timestampPostRsvpProcessing,
    };
};

export const setTimeToFetchConflictingMeetings = (
    itemId: string,
    startTimestamp: number,
    endTimestamp: number
) => {
    if (!itemId || !startTimestamp || !startTimestamp) {
        return;
    }

    timeToFetchConflictingMeetings[itemId] = { startTimestamp, endTimestamp };
};

export const getTimeToFetchMeetingMessage = (itemId: string): Timestamp => {
    if (!itemId || !timeToFetchMeetingMessage[itemId]) {
        return null;
    }

    return timeToFetchMeetingMessage[itemId];
};

export const getTimeToFetchConflictingMeetings = (itemId: string): Timestamp => {
    if (!itemId || !timeToFetchConflictingMeetings[itemId]) {
        return null;
    }

    return timeToFetchConflictingMeetings[itemId];
};
